var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUserTime = function SvgUserTime(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8.107 7.247a1.2 1.2 0 0 0-.22 0A2.947 2.947 0 0 1 5.04 4.293a2.95 2.95 0 0 1 2.953-2.96 2.96 2.96 0 0 1 2.96 2.96c0 1.6-1.266 2.9-2.846 2.954M7.993 14.54c-1.213 0-2.42-.307-3.34-.92-1.613-1.08-1.613-2.84 0-3.913 1.834-1.227 4.84-1.227 6.674 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.667,
    d: "M13.333 13.333a2 2 0 1 1-4.001-.001 2 2 0 0 1 4.001.001"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.667,
    d: "m12.076 13.97-.62-.37a.44.44 0 0 1-.196-.345v-.82"
  })));
};
export default SvgUserTime;